module.exports = __webpack_public_path__ + "static/media/portrait.374f9e5d.jpg";